export const DevDomain = 'http://120.55.102.114:8352';
export const prePreviewFile = '/dataspace-api/commonfile/preview?fileName=';
export const preDownloadFile = '/dataspace-api/commonfile/download?fileName=';
